/* eslint-disable react/prop-types */
import React from 'react';

const InputThreeSidesDisplay = ({ stroke, ...props }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="63"
      height="63"
      rx="7.5"
      fill="#F4F6F9"
      stroke={stroke || '#A6A7B0'}
    />
    <mask id="path-2-inside-1_406_8437" fill="white">
      <path d="M8 25H56V39H8V25Z" />
    </mask>
    <path d="M8 25H56V39H8V25Z" fill="#D9D9D9" />
    <path
      d="M56 39V40H57V39H56ZM8 39H7V40H8V39ZM55 25V39H57V25H55ZM56 38H8V40H56V38ZM9 39V25H7V39H9Z"
      fill="black"
      mask="url(#path-2-inside-1_406_8437)"
    />
  </svg>
);

export default InputThreeSidesDisplay;
